import { useNavigate } from "react-router-dom";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../lib/firebase";

const Login = () => {
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      if (user.email === "nishantdhamija41@gmail.com" || user.email === "varundhamija95@gmail.com") {
        localStorage.setItem("isAuthenticated", "true");
        navigate("/");
      } else {
        alert("You are not authorized to access this application.");
        auth.signOut();
      }
    } catch (error) {
      console.error("Error during Google login:", error);
      alert("An error occurred during login. Please try again.");
    }
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold text-center">Login with Google</h1>
        <button
          onClick={handleGoogleLogin}
          className="w-full px-4 py-2 font-bold text-white bg-red-500 rounded-md"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
};

export default Login;
